import type { ResponsiveValue } from 'styled-system';

import type { GridItemProps } from '../extensions';
import { gridItem } from '../extensions';
import styledFactory from '../styledFactory';
import variantFactory from '../variantFactory';

export interface Props extends GridItemProps {
  variant?: ResponsiveValue<string>;
  __dividerCommon__?: 'common';
}

/**
 * Divider is a component that renders a styled hr element.
 */
const Divider = styledFactory<Props, 'hr'>(
  'hr',
  'Divider',
  [
    variantFactory('components.divider', { prop: '__dividerCommon__' }),
    variantFactory('components.divider.variants'),
  ],
  [gridItem],
  `border: none;`,
  {
    variant: 'default',
    __dividerCommon__: 'common',
  },
);

export default Divider;
